import { useState } from "react";
import FormInput from "../common/FormInput";
import { postFormData } from "../../utilities/formSubmission";

function FellowshipForm() {
  const options = [
    "Partner to set up makerspaces or kits",
    "Collaborate on district-wide programs",
    "Collaborate on curriculum development",
    "Collaborate on teacher training",
    "Bring MakerDost AI to my institution",
  ];

  const [profession, setProfession] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [interest, setInterest] = useState("");
  const [message, setMessage] = useState("");
  const [agreeUpdates, setAgreeUpdates] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async () => {
    console.log(name, profession, email, phone, interest, message);

    setIsSubmitting(true);

    const trimmedName = name.trim();
    const trimmedProfession = profession.trim();
    const trimmedEmail = email.trim();
    const trimmedPhone = phone.trim();
    const trimmedInterest = interest.trim();
    const trimmedMessage = message.trim();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\d{10}$/;

    if (
      !trimmedName ||
      !trimmedProfession ||
      !trimmedEmail ||
      !trimmedPhone ||
      !trimmedInterest ||
      !emailRegex.test(trimmedEmail) ||
      !phoneRegex.test(trimmedPhone)
    ) {
      alert("Please fill in all required fields with valid information.");
      setIsSubmitting(false);
      return;
    }

    const formData = {
      name: trimmedName,
      profession: trimmedProfession,
      email: trimmedEmail,
      phone: trimmedPhone,
      interest: trimmedInterest,
      message: trimmedMessage,
      agreeUpdates: agreeUpdates,
      action: "mgfellowForm",
    };

    try {
      const response = await postFormData(formData);

      setName("");
      setProfession("");
      setEmail("");
      setPhone("");
      setAgreeUpdates(true);
      setInterest("");
      setMessage("");

      console.log("response", response);
      setSubmitted(true);
      setIsSubmitting(false);

      setTimeout(() => {
        setSubmitted(false);
      }, 3000);
    } catch (error) {
      console.error("Error submitting form after retries:", error);
      alert("An error occurred while submitting the form. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <div className="fellowship-form">
      <FormInput
        label="I am a"
        placeholder="Enter profession"
        value={profession}
        setValue={setProfession}
      />

      <FormInput
        type="select"
        label="Looking forward to"
        placeholder="Select your interest"
        options={options}
        value={interest}
        setValue={setInterest}
      />

      <FormInput
        label="My name"
        placeholder="Enter name"
        value={name}
        setValue={setName}
      />

      <FormInput
        type="email"
        label="Phone number"
        placeholder="Enter phone number"
        value={phone}
        setValue={setPhone}
      />

      <FormInput
        type="email"
        label="Email Id"
        placeholder="Enter email address"
        value={email}
        setValue={setEmail}
      />

      <FormInput
        type="checkbox"
        label="Receive updates via email"
        value={agreeUpdates}
        setValue={setAgreeUpdates}
      />

      <FormInput
        optional
        type="textarea"
        label="Optional"
        placeholder="Type to convey something"
        value={message}
        setValue={setMessage}
      />

      <button disabled={isSubmitting} onClick={handleSubmit} type="button">
        {submitted ? "Submitted" : isSubmitting ? "Submitting" : "Submit"}
      </button>
    </div>
  );
}

export default FellowshipForm;
